import React from 'react';
import Select from 'react-select';
import {
  MultiValueLabel,
  MultiValueRemove,
} from '../../AddSegment/components/labels';
import { placeholderStyle } from '../../AddSegment/Condition/Condition.constants';
import styles from '../Contacts.module.scss';
import { REACH_METHODS } from './data';

const ReachMethods = ({ reachMethods, setReachMethods, isLoading }) => (
  <div className={styles.filter_row}>
    <span className={styles.label}>Reach Methods</span>
    <Select
      className="mb-4"
      placeholder="Select reach methods"
      maxMenuHeight={194}
      onChange={(newValue) => {
        setReachMethods(newValue);
      }}
      value={reachMethods}
      options={REACH_METHODS}
      isMulti
      isLoading={isLoading}
      styles={placeholderStyle}
      components={{
        // eslint-disable-next-line react/no-unstable-nested-components
        MultiValueRemove: (props) => (
          <MultiValueRemove props={props} show="label" />
        ),
        // eslint-disable-next-line react/no-unstable-nested-components
        MultiValueLabel: (props) => (
          <MultiValueLabel props={props} show="label" />
        ),
      }}
    />
  </div>
);

export default ReachMethods;
